import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-of-your-interest',
  templateUrl: './of-your-interest.component.html',
  styleUrls: ['./of-your-interest.component.scss']
})
export class OfYourInterestComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
    $(document).ready(() => {
      $('#ofYourInterestCarousel').on('slide.bs.carousel', function (e: any) {
        const $e = $(e.relatedTarget);
        const direction = e.direction;
        const idx = $e.index();
        const itemsPerSlide = 4;
        const totalItems = $('.carousel-item-product').length;
        if (idx >= totalItems - itemsPerSlide - 1) {
          const it = itemsPerSlide - (totalItems - idx) + 1;
          for (let i = 0; i < it; i++) {
            if (direction === 'left') {
              $('.carousel-item-product')
                .eq(i)
                .appendTo('.carousel-inner-product');
            } else {
              $('.carousel-item-product')
                .eq(0)
                .appendTo($(this).find('.carousel-inner-product'));
            }
          }
        }
      });
    });
  }

}
